import { inject, singleton } from 'tsyringe';
import { IDirectScraperConfig, ServerSettings } from './settings/server-settings';

@singleton()
export class DirectScraperConfig {

  public readonly settings: IDirectScraperConfig;

  constructor(@inject(ServerSettings) serverSettings: ServerSettings) {
    this.settings = serverSettings.settings.directScraper;
  }
}
